import { twMerge } from "tailwind-merge"

export const Container = ({ children, className }) => {
    return (
        <div className={twMerge("w-10/12 mx-auto", className)}>{children}</div>
    )
}